import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import User, { AuthProvider } from "react-oidc-context";
import { AuthProviderProps } from "react-oidc-context";

const getTenantString = () => {
  return (`tenant:${getTenantFromURL()}`);
}

const getTenantFromURL = () => {
  return sessionStorage.getItem('companyID') || '';
}

const signinCallback = (): void => {
  window.history.replaceState(
      {},
      document.title,
      window.location.pathname
  )
}

const oidcConfig: AuthProviderProps = {
  authority: `${process.env.REACT_APP_ID4URL}`,
  client_id: "apidocs",
  acr_values: getTenantString(), 
  redirect_uri: `${window.location.href}`,
  scope: "api1",
  response_type: "code",
  metadata: {
    authorization_endpoint: `${process.env.REACT_APP_ID4URL}/IdentityServerAPI/IdentityServerAPI/connect/authorize`,
    token_endpoint: `${process.env.REACT_APP_ID4URL}/IdentityServerAPI/IdentityServerAPI/connect/token?acr_values=${getTenantString()}`,
    revocation_endpoint: `${process.env.REACT_APP_ID4URL}/IdentityServerAPI/IdentityServerAPI/connect/revocation`,
    introspection_endpoint: `${process.env.REACT_APP_ID4URL}/IdentityServerAPI/IdentityServerAPI/connect/introspect`,
    userinfo_endpoint: `${process.env.REACT_APP_ID4URL}/IdentityServerAPI/IdentityServerAPI/connect/userinfo`,
    jwks_uri: `${process.env.REACT_APP_ID4URL}/IdentityServerAPI/IdentityServerAPI/.well-known/openid-configuration/jwks`,
  },
    onSigninCallback : signinCallback
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <AuthProvider {...oidcConfig}>
    <App />
  </AuthProvider>
);

reportWebVitals();
